export enum ColumnValuesEnum {
  IssueDate,
  InvoiceNumber,
  SupplierName,
  TotalAmount,
  DueDate,
  BalanceDue,
  Payment1,
  Payment2,
  Payment3,
  Payment4,
  Payment5,
  Payment6,
  Payment7,
  Payment8,
  Payment9,
  Payment10,
  Payment11,
  Payment12,
}

export enum LedgerColumnDbMapping {
  Date,
  Invoice_Number,
  supplier_Name,
  Total_Amount,
  Due_Date,
  Balance_due,
  Payment1,
  Payment2,
  Payment3,
  Payment4,
  Payment5,
  Payment6,
  Payment7,
  Payment8,
  Payment9,
  Payment10,
  Payment11,
  Payment12,
}

export enum TodoColumnDbMapping {
  Task_Number,
  Task_Description,
  Task_Priority,
  Task_Status,
}

export enum TodoColumnEnum {
  TaskNumber,
  TaskDescription,
  TaskPriority,
  TaskStatus,
}

export enum SpreadJSShapeTypes {
  CheckBox = 5,
}

export enum NPOIShapeTypes {
  None = 0,
  Line = 1,
  LineInv = 2,
  Triangle = 3,
  RightTriangle = 4,
  Rectangle = 5,
  Diamond = 6,
  Parallelogram = 7,
  Trapezoid = 8,
  NonIsoscelesTrapezoid = 9,
  Pentagon = 10,
  Hexagon = 11,
  Heptagon = 12,
  Octagon = 13,
  Decagon = 14,
  Dodecagon = 15,
  Star4 = 16,
  Star5 = 17,
  Star6 = 18,
  Star7 = 19,
  Star8 = 20,
  Star10 = 21,
  Star12 = 22,
  Star16 = 23,
  Star24 = 24,
  Star32 = 25,
  RoundedRectangle = 26,
  Rounded1Rectangle = 27,
  Rounded2SameRectangle = 28,
  Rounded2DiagonalRectangle = 29,
  SnipRoundedRectangle = 30,
  Snip1Rectangle = 31,
  Snip2SameRectangle = 32,
  Snip2DiagonalRectangle = 33,
  Plaque = 34,
  Ellipse = 35,
  Teardrop = 36,
  HomePlate = 37,
  Chevron = 38,
  PieWedge = 39,
  Pie = 40,
  BlockArc = 41,
  Donut = 42,
  NoSmoking = 43,
  RightArrow = 44,
  LeftArrow = 45,
  UpArrow = 46,
  DownArrow = 47,
  StripedRightArrow = 48,
  NotchedRightArrow = 49,
  BentUpArrow = 50,
  LeftRightArrow = 51,
  UpDownArrow = 52,
  LeftUpArrow = 53,
  LeftRightUpArrow = 54,
  QuadArrow = 55,
  LeftArrowCallout = 56,
  RightArrowCallout = 57,
  UpArrowCallout = 58,
  DownArrowCallout = 59,
  LeftRightArrowCallout = 60,
  UpDownArrowCallout = 61,
  QuadArrowCallout = 62,
  BentArrow = 63,
  UTurnArrow = 64,
  CircularArrow = 65,
  LeftCircularArrow = 66,
  LeftRightCircularArrow = 67,
  CurvedRightArrow = 68,
  CurvedLeftArrow = 69,
  CurvedUpArrow = 70,
  CurvedDownArrow = 71,
  SwooshArrow = 72,
  Cube = 73,
  Can = 74,
  LightningBolt = 75,
  Heart = 76,
  Sun = 77,
  Moon = 78,
  SmileyFace = 79,
  IrregularSeal1 = 80,
  IrregularSeal2 = 81,
  FoldedCorner = 82,
  Bevel = 83,
  Frame = 84,
  HalfFrame = 85,
  Corner = 86,
  DiagonalStripe = 87,
  Chord = 88,
  Arc = 89,
  LeftBracket = 90,
  RightBracket = 91,
  LeftBrace = 92,
  RightBrace = 93,
  BracketPair = 94,
  BracePair = 95,
  StraightConnector1 = 96,
  BentConnector2 = 97,
  BentConnector3 = 98,
  BentConnector4 = 99,
  BentConnector5 = 100,
  CurvedConnector2 = 101,
  CurvedConnector3 = 102,
  CurvedConnector4 = 103,
  CurvedConnector5 = 104,
  Callout1 = 105,
  Callout2 = 106,
  Callout3 = 107,
  AccentCallout1 = 108,
  AccentCallout2 = 109,
  AccentCallout3 = 110,
  BorderCallout1 = 111,
  BorderCallout2 = 112,
  BorderCallout3 = 113,
  AccentBorderCallout1 = 114,
  AccentBorderCallout2 = 115,
  AccentBorderCallout3 = 116,
  WedgeRectangleCallout = 117,
  WedgeRoundRectangleCallout = 118,
  WedgeEllipseCallout = 119,
  CloudCallout = 120,
  Cloud = 121,
  Ribbon = 122,
  Ribbon2 = 123,
  EllipseRibbon = 124,
  EllipseRibbon2 = 125,
  LeftRightRibbon = 126,
  VerticalScroll = 127,
  HorizontalScroll = 128,
  Wave = 129,
  DoubleWave = 130,
  Plus = 131,
  FlowChartProcess = 132,
  FlowChartDecision = 133,
  FlowChartInputOutput = 134,
  FlowChartPredefinedProcess = 135,
  FlowChartInternalStorage = 136,
  FlowChartDocument = 137,
  FlowChartMultiDocument = 138,
  FlowChartTerminator = 139,
  FlowChartPreparation = 140,
  FlowChartManualInput = 141,
  FlowChartManualOperation = 142,
  FlowChartConnector = 143,
  FlowChartPunchedCard = 144,
  FlowChartPunchedTape = 145,
  FlowChartSummingJunction = 146,
  FlowChartOr = 147,
  FlowChartCollate = 148,
  FlowChartSort = 149,
  FlowChartExtract = 150,
  FlowChartMerge = 151,
  FlowChartOfflineStorage = 152,
  FlowChartOnlineStorage = 153,
  FlowChartMagneticTape = 154,
  FlowChartMagneticDisk = 155,
  FlowChartMagneticDrum = 156,
  FlowChartDisplay = 157,
  FlowChartDelay = 158,
  FlowChartAlternateProcess = 159,
  FlowChartOffpageConnector = 160,
  ActionButtonBlank = 161,
  ActionButtonHome = 162,
  ActionButtonHelp = 163,
  ActionButtonInformation = 164,
  ActionButtonForwardNext = 165,
  ActionButtonBackPrevious = 166,
  ActionButtonEnd = 167,
  ActionButtonBeginning = 168,
  ActionButtonReturn = 169,
  ActionButtonDocument = 170,
  ActionButtonSound = 171,
  ActionButtonMovie = 172,
  Gear6 = 173,
  Gear9 = 174,
  Funnel = 175,
  MathPlus = 176,
  MathMinus = 177,
  MathMultiply = 178,
  MathDivide = 179,
  MathEqual = 180,
  MathNotEqual = 181,
  CornerTabs = 182,
  SquareTabs = 183,
  PlaqueTabs = 184,
  ChartX = 185,
  ChartStar = 186,
  ChartPlus = 187,
}

export enum ListType {
  Templates = "templates",
  Coa = "coa",
}
